import { getDisplayAssetCode } from '@altify/utils';
import { ElementType } from 'react';
import { InputLikeButton } from '../../../../Core/Button/InputLikeButton';
import { Typography } from '../../../../Core/Typography/Typography';
import { DropdownIcon } from '../../../../Icons/DropdownIcon';
import { IconProps } from '../../../../Icons/Icons.types';

export type AssetSelectProps = {
  iconProps?: IconProps;
  title: string;
  placeholder?: string;
  className?: string;
  rounded?: 'full' | 'left' | 'right';
  onPress: () => void;
  selectedAssetCode?: string;
  iconComponent?: ElementType;
  showDropdownIcon?: boolean;
  disabled?: boolean;
  hasError?: boolean;
  isFocused?: boolean;
};

export const AssetSelect = ({
  onPress,
  title,
  hasError = false,
  rounded = 'full',
  className,
  selectedAssetCode,
  placeholder = '-',
  iconComponent: IconComponent,
  iconProps,
  showDropdownIcon = true,
  disabled = false,
  isFocused = false,
}: AssetSelectProps) => {
  const value =
    selectedAssetCode == null
      ? placeholder
      : getDisplayAssetCode(selectedAssetCode);

  return (
    <InputLikeButton
      name={title}
      placeholder={placeholder}
      disabled={disabled}
      isFocused={isFocused}
      className={className}
      rounded={rounded}
      hasError={hasError}
      onPress={onPress}>
      <>
        {selectedAssetCode != null && IconComponent && (
          <IconComponent {...iconProps} className="mr-2" />
        )}
        <Typography weight="medium" size="large" className="mr-1">
          {value}
        </Typography>
        {showDropdownIcon && (
          <DropdownIcon stroke="white" className="ml-auto" />
        )}
      </>
    </InputLikeButton>
  );
};
